export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-secondary-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50 whitespace-nowrap">日韩影视网</span>
            </div>
            <p className="text-sm text-secondary-400 leading-relaxed mb-4">
              日韩影视网提供免费的日本电影与韩国电影在线观看服务，涵盖最新日韩电影高清资源。经典大片与新片速递一网打尽，高清画质急速播放，无需注册即可畅享免费日韩电影。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '热播榜单', href: '#ranking' },
                { label: '精彩预告', href: '#media' },
                { label: '分类索引', href: '#index' },
                { label: '移动看片', href: '#app' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-secondary-400 hover:text-background-50 transition-colors no-underline whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">电影分类</h4>
            <div className="flex flex-col gap-2">
              {['韩国动作片', '日本动画电影', '日韩爱情片', '悬疑惊悚', '恐怖片合集'].map((cat) => (
                <a
                  key={cat}
                  href="#index"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-secondary-400 hover:text-background-50 transition-colors no-underline whitespace-nowrap"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-secondary-500 leading-relaxed">
              日韩影视网持续拓展影视内容合作渠道，欢迎优质片方与内容提供商洽谈合作。更多合作伙伴信息敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-500">
            &copy; 2020-2026 日韩影视网 rihanys.com - 免费日韩电影在线观看
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="text-xs text-secondary-500 hover:text-background-50 transition-colors no-underline"
            >
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}